module.exports = __webpack_public_path__ + "assets/img/vtuber-app2.f3952be2.png";